var Account, AccountState, ActionFactories, AdminPage, Breadcrumbs, HeadingBar, Page, m;

m = require('mithril');

ActionFactories = require('../../state/ActionFactories');

AccountState = require('../../state/Account');

Account = require('../components/Account');

Page = require('../components/Page');

HeadingBar = require('../components/HeadingBar');

Breadcrumbs = require('../components/Breadcrumbs');

AdminPage = {
  controller: function(args) {
    var ctrl, readJsonFile;
    readJsonFile = function(file) {
      var deferred, reader;
      deferred = m.deferred();
      reader = new FileReader;
      reader.onload = function(e) {
        var json, lib;
        json = e.target.result;
        lib = JSON.parse(json);
        return deferred.resolve(lib);
      };
      reader.readAsText(file);
      return deferred.promise;
    };
    ctrl = this;
    ctrl.loadLibrary = function(e) {
      var file;
      e.preventDefault();
      file = e.target.files[0];
      if (file == null) {
        return;
      }
      return readJsonFile(file).then(function(lib) {
        var p;
        lib.photos = (function() {
          var i, len, ref, results;
          ref = lib.photos;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            p = ref[i];
            if (!p.dummy) {
              results.push(p);
            }
          }
          return results;
        })();
        lib.photos.sort(function(a, b) {
          if (a.timestamp.epoch < b.timestamp.epoch) {
            return -1;
          }
          if (a.timestamp.epoch > b.timestamp.epoch) {
            return 1;
          }
          return 0;
        });
        return args.libraryLoaded(lib);
      });
    };
    ctrl.loadGallery = function(e) {
      var file;
      e.preventDefault();
      file = e.target.files[0];
      if (file == null) {
        return;
      }
      return readJsonFile(file).then(args.galleryLoaded);
    };
    ctrl.newGallery = function() {
      return args.galleryLoaded({
        id: 0,
        name: 'New',
        photos: []
      });
    };
    return ctrl;
  },
  view: function(ctrl, args) {
    var account, editGallery, library;
    account = args.account();
    library = args.library();
    editGallery = args.editGallery();
    return m(Page, {
      account: account,
      content: [
        m(HeadingBar, {
          content: m(Breadcrumbs, {
            items: [
              {
                icon: 'home',
                title: 'Home',
                onclick: function() {
                  return m.route('/home');
                }
              }, {
                icon: 'warning',
                content: 'Admin'
              }
            ]
          })
        }), m('h1', 'Admin'), m('h2', 'Library'), m('p', "Images: " + library.photos.length), m('p', m('input[type=file][required=required]', {
          onchange: ctrl.loadLibrary
        })), m('h2', 'Gallery'), m('p', "'" + editGallery.name + "' [ID: " + editGallery.id + "], " + editGallery.photoIds.length + " images"), m('p', m('input[type=file][required=required]', {
          onchange: ctrl.loadGallery
        })), m('p', m('input[type=button][value=New]', {
          onclick: ctrl.newGallery
        }, 'New')), m('p', m('a[href=/admin/editGallery]', {
          config: m.route
        }, 'Edit')), m('p', m('a[href=/admin/exportGallery]', {
          config: m.route
        }, 'Export'))
      ]
    });
  }
};

module.exports = function(store) {
  return m(AdminPage, {
    account: function() {
      return store.getState().account;
    },
    library: function() {
      return store.getState().library;
    },
    editGallery: function() {
      return store.getState().editGallery;
    },
    libraryLoaded: function(lib) {
      return store.dispatch(ActionFactories.libraryLoaded(lib));
    },
    galleryLoaded: function(gallery) {
      return store.dispatch(ActionFactories.editGalleryLoaded(gallery));
    }
  });
};

//# sourceMappingURL=data:application/json;base64,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
